var map = {
	"./ar.agriculture.json": 96853,
	"./ar.facilities.json": 90137,
	"./ar.homepage.json": 43816,
	"./ar.json": 5310,
	"./ar.landingpage.json": 93604,
	"./ar.lawsandregulations.json": 86919,
	"./ar.login.json": 33437,
	"./ar.maps.json": 2011,
	"./ar.navbar.json": 370,
	"./ar.pollutants.json": 41322,
	"./ar.reports.json": 99759,
	"./ar.sectors.json": 96551,
	"./ar.solid.json": 59459,
	"./ar.uploadfilesandmaps.json": 48622,
	"./ar.users.json": 93284,
	"./en.governorates.json": 47419,
	"./en.json": 44174,
	"./en.pollutants.json": 93018,
	"./en.solid.json": 52851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84649;